import { useSelector } from "react-redux";
import React from 'react';
import {Row, Col} from "reactstrap";
import "../../../../Assets/Scss/newHome2.scss";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../../Config/axiosInstance";


export default function MostTrending() {

const { topRatedStores } = useSelector((state) => state.Stores);


	return(
		<>
    <div className="carousel pt-0 pb-0" id="recommended-res" style={{backgroundColor:"aliceblue"}}>
		       
<div class="three2" style={{
	padding:"3vh 0 2vh 0",
  display:"flex",
  alignItems:"center",
  justifyContent:"center",
}} >
  <h1 style={{marginRight:"10%"}}>Most Trending Stores</h1>
</div>
		<Row>
			{topRatedStores.slice(0,10).map((store, i)=>{
				return(
				<Col  xl="2" sm="4" id="brands-index2"  style={{padding: "0", backgroundColor:"white", marginBottom:"1.6%"}}>
                <Link to={`/store/${store.store_details.slug}`} style={{padding: "0", margin: "0"}}>
                <div className="card rounded shadow-sm border-0">
  <div className="card-body" style={{padding: "5px 20px"}}>
    <img
      src={`${BASE_URL}/${store?.store_details?.image}`}
      alt=""
      id="i3-stores-card-img"
      className="img-fluid d-block mx-auto mb-3"
      style={{width:"100%", height:"190px"}}
      loading="lazy"
    />
    <h5 style={{margin:"0", padding:"0", height:"30px"}}>
      {" "}
      <a style={{color:"rgb(2, 137, 80)", margin:"0", padding:"0"}}>
        {store?.store_details?.slug}
      </a>
    </h5>
    <p className="small text-muted font-italic"  style={{color:"rgb(2, 137, 80)", margin:"0", padding:"0"}}>
        Find all coupons and deals of {store?.store_details?.slug}
    </p>
    <ul className="list-inline small" style={{marginBottom: "0", paddingBottom:"0"}}>
      <li className="list-inline-item m-0">
        <i className="fa fa-star text-success" />
      </li>
      <li className="list-inline-item m-0">
        <i className="fa fa-star text-success" />
      </li>
      <li className="list-inline-item m-0">
        <i className="fa fa-star text-success" />
      </li>
      <li className="list-inline-item m-0">
        <i className="fa fa-star text-success" />
      </li>
      <li className="list-inline-item m-0">
        <i className="fa fa-star-o text-success" />
      </li>
    </ul>
  </div>
</div>
    </Link>
				</Col>

					)
			})}
			</Row>
	</div>
	</>
	)
}
